// SHORT_INTEREST widget - maps to data-provider/source/instructions/SHORT_INTEREST
import type { RangeOption } from '../../../blocks/chart-widget';

export type ShortInterestChartRange = '3M' | '6M' | 'ALL';

// FINRA settlements are bi-monthly, so ranges slice by calendar months
// (row counts don't map cleanly to elapsed time). The consolidated FINRA
// dataset only covers one rolling year, so deeper ranges aren't offered.
export const SHORT_INTEREST_RANGE_OPTIONS: Array<RangeOption & { value: ShortInterestChartRange }> = [
  { value: '3M', label: '3M', months: 3 },
  { value: '6M', label: '6M', months: 6 },
  { value: 'ALL', label: 'All' },
];

// Provider options reflect this fork's adapted contract:
//  - short interest: FINRA (the only consolidated source wired here)
//  - price/context:  FMP or INSYNC
// (shares outstanding comes from SEC automatically; no user selection.)
export interface ShortInterestWidgetConfig {
  short_interest_provider?: 'AUTO' | 'FINRA';
  price_provider?: 'AUTO' | 'FMP' | 'INSYNC';
  /** Initially selected chart range (user can change it on the widget). */
  defaultRange?: ShortInterestChartRange;
}

export interface ShortInterestWidgetInstanceConfig extends ShortInterestWidgetConfig {
  dataKey?: string;
}

export interface ShortInterestHistoryRow {
  date: string;
  shares_short: number | null;
  shares_short_prev: number | null;
  change_pct: number | null;
  avg_daily_volume: number | null;
  days_to_cover: number | null;
}

export interface ShortInterestPriceRow {
  date: string;
  price: number;
}

// API response shape from the data-provider SHORT_INTEREST widget.
export interface ShortInterestData {
  ticker: string;
  company_name: string | null;
  settlement_date: string | null;
  shares_short: number | null;
  shares_short_prev: number | null;
  change_pct: number | null;
  avg_daily_volume: number | null;
  days_to_cover: number | null;
  market_cap: number | null;
  close_price: number | null;
  adtv_3m: number | null;
  shares_outstanding?: number | null;
  si_pct_outstanding?: number | null;
  short_interest_history: ShortInterestHistoryRow[] | null;
  price_history: ShortInterestPriceRow[] | null;
}
